<template>
  <div class="meeting-info wap-wrapper">
    <header class="banner-container">
      <div class="banner-img-container">
        <van-image
          :src="template.meetingInfo.banner.src.value"
          width="100%"
        ></van-image>
      </div>
      <div class="banner-txt-container">
        <p
          class="banner-txt-title"
          v-bind:style="{
            color: template.meetingInfo.webinar_title.color.value
          }"
          v-if="template.meetingInfo.webinar_title.display.value"
        >
          {{ webinarInfo.title }}
        </p>
        <p
          class="banner-txt-date"
          v-bind:style="{
            color: template.meetingInfo.webinar_date
              ? template.meetingInfo.webinar_date.color.value
              : '#fff'
          }"
          v-if="
            (template.meetingInfo.webinar_date
              ? template.meetingInfo.webinar_date.display.value
              : true) &&
              webinarInfo.replaySwitch !== 1 &&
              !ReplayliveState
          "
        >
          {{ startDate }}-{{ endDate }}
        </p>
      </div>
    </header>
    <InfoTabs></InfoTabs>
    <div class="content-container">
      <PanelTitle
        v-if="template.meetingInfo.tab_1_p.display.value"
        :title="template.meetingInfo.tab_1_p.text.value"
        :en-title="'CONFERENCE INTRODUCTION'"
        :isBack="false"
        :id="'intro'"
      ></PanelTitle>
      <Info v-if="template.meetingInfo.tab_1_p.display.value"></Info>
      <PanelTitle
        v-if="template.meetingInfo.tab_2_p.display.value"
        :title="template.meetingInfo.tab_2_p.text.value"
        :en-title="'CONFERENCE AGENDA'"
        :isBack="true"
        :id="'agenda'"
      ></PanelTitle>
      <agenda v-if="template.meetingInfo.tab_2_p.display.value"></agenda>
      <PanelTitle
        v-if="template.meetingInfo.tab_3_p.display.value"
        :title="template.meetingInfo.tab_3_p.text.value"
        :en-title="'CONFERENCE GUEST'"
        :isBack="false"
        :id="'guest'"
      ></PanelTitle>
      <div v-if="template.meetingInfo.tab_3_p.display.value">
        <GuestInfo></GuestInfo>
      </div>
      <PanelTitle
        v-if="template.meetingInfo.tab_4_p.display.value"
        :title="template.meetingInfo.tab_4_p.text.value"
        :en-title="''"
        :isBack="true"
        :id="'custom'"
      ></PanelTitle>
      <div v-if="template.meetingInfo.tab_4_p.display.value">
        <Expand></Expand>
      </div>
    </div>
    <Card :webinarLive="'webinarLive'"></Card>
    <BottomBar></BottomBar>
    <LoginState></LoginState>
  </div>
</template>

<script>
import $ from "jquery";
import { $subscriber, ck, URLS } from "fire-wind-water";
import * as moment from "moment";
import InfoTabs from "../../components/common/InfoTabs";
import PanelTitle from "../../components/common/PanelTitle";
import GuestInfo from "../../components/wap/GuestInfo";
import BottomBar from "../../components/wap/BottomBar";
import LoginState from "../../components/wap/LoginState";
import Expand from "../../components/wap/Expand";
import Info from "../../components/wap/Info";
import Agenda from "../../components/wap/Agenda";
import { mixinsTemplate } from "../../common/mixinsTemplate";
import user from "../../common/user";
import { showShareTip } from "../../common/sbase";
import Card from "../../../stempcore/src/core/components/common/Card";
export default {
  name: "wapMeetingInfo",
  mixins: [mixinsTemplate],
  data() {
    return {
      bannerImgUrl: "", // banner图地址
      webinarInfo: {},
      // 当前激活的和Tab
      currentTab: {},
      endDate: "",
      startDate: "",
      userInfo: {},
      ReplayliveState:
        window.location.href.indexOf("liveState=replay") > -1 &&
        window.location.href.indexOf("isSetting=1") > -1
          ? true
          : false //静态链接回放状态
    };
  },
  computed: {},
  methods: {},
  components: {
    InfoTabs,
    PanelTitle,
    GuestInfo,
    BottomBar,
    LoginState,
    Info,
    Agenda,
    Expand,
    Card
  },
  created() {
    this.bannerImgUrl = require("@/assets/images/banner-def.jpg");
    if (URLS.getURL("markPreview")) {
      showShareTip();
    }
  },
  mounted() {
    $subscriber.subscribe("webinarInfo.a", data => {
      this.webinarInfo = data;
      this.startDate = moment(data.startTime).format("YYYY年MM月DD日 HH:mm");
      this.endDate = moment(data.endTime).format("HH:mm");
      // user.userLoad(data).then(() => {
      //   window.$sk.loading.hide();
      // });
    });
    $subscriber.subscribe("userInfo", data => {
      this.userInfo = data;
      const user1 = {
        cookie: null
      };
      user1.cookie = ck.cookie("smarketMember_" + this.webinarInfo.schemaId);
      if (user1.cookie != "" && user1.cookie != null) {
        this.userInfo.isLogin = true;
        this.userInfo.session = user1.cookie.session;
      } else {
        this.userInfo.isLogin = false;
        this.userInfo.session = "";
      }
    });
  },
  updated() {},
  beforeDestroy() {
    $subscriber.off("webinarInfo.a");
  }
};
</script>
